// src/Redux/thunks/eventsThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosEvents } from "../../../api/axios";
import ENDPOINTS from "../../../api/endpoints";

const { EVENTS: EVENTS_PATHS } = ENDPOINTS;

export const fetchEventsByDoctor = createAsyncThunk(
  "events/fetchByDoctor",
  async (doctorId, { rejectWithValue }) => {
    try {
      const res = await axiosEvents.get(
        EVENTS_PATHS.BY_DOCTOR(doctorId),
        { withCredentials: true }
      );
      return res.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch events";
      return rejectWithValue(message);
    }
  }
);

export const fetchEventsByDay = createAsyncThunk(
  "events/fetchByDay",
  async ({ date }, { rejectWithValue }) => {
    try {
      const res = await axiosEvents.get(
        EVENTS_PATHS.BY_DAY(date),
        { withCredentials: true }
      );
      return res.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch events for day";
      return rejectWithValue(message);
    }
  }
);

export const fetchEventsByRange = createAsyncThunk(
  "events/fetchByRange",
  async ({ startDate, endDate }, { rejectWithValue }) => {
    try {
      const res = await axiosEvents.get(
        EVENTS_PATHS.BY_RANGE(startDate, endDate),
        { withCredentials: true }
      );
      return res.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch events for range";
      return rejectWithValue(message);
    }
  }
);

export const createEventForDoctor = createAsyncThunk(
  "events/createForDoctor",
  async ({ doctorId, eventData }, { rejectWithValue }) => {
    try {
      const res = await axiosEvents.post(
        EVENTS_PATHS.CREATE(doctorId),
        eventData,
        { withCredentials: true }
      );
      return res.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to create event";
      return rejectWithValue(message);
    }
  }
);

export const updateEvent = createAsyncThunk(
  "events/update",
  async ({ id, eventData }, { rejectWithValue }) => {
    try {
      const res = await axiosEvents.patch(
        EVENTS_PATHS.UPDATE(id),
        eventData,
        { withCredentials: true }
      );
      return res.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to update event";
      return rejectWithValue(message);
    }
  }
);

export const deleteEvent = createAsyncThunk(
  "events/delete",
  async (id, { rejectWithValue }) => {
    try {
      const res = await axiosEvents.delete(EVENTS_PATHS.DELETE(id), {
        withCredentials: true,
      });
      return { id, ...(res.data || {}) };
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to delete event";
      return rejectWithValue(message);
    }
  }
);

export const hardDeleteEvent = createAsyncThunk(
  "events/hardDelete",
  async (id, { rejectWithValue }) => {
    try {
      const res = await axiosEvents.delete(EVENTS_PATHS.HARD_DELETE(id), {
        withCredentials: true,
      });
      return { id, ...(res.data || {}) };
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to hard delete event";
      return rejectWithValue(message);
    }
  }
);